import { mergeModules } from "../core"
import list from "./list"

export default mergeModules(list)
